import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { CatalogViewComponentDef } from '@df/catalog-ui/catalog-view.component.def';
import { GiftcardsProductViewComponent } from '../../module/giftcards/giftcards-product-view.component';
import { LocalProduct } from '../model/product/product.decorator';
import { CategoryViewComponent } from './category/category-view.component';
import { Error404Component } from './error-404.component';
import { PageViewComponent } from './page/page-view.component';
import { ProductViewComponent } from './product/product-view.component';
@Component({
    selector: 'catalog-view',
    templateUrl: 'catalog-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        forwardRef(() => PageViewComponent),
        forwardRef(() => CategoryViewComponent),
        GiftcardsProductViewComponent,
        ProductViewComponent,
        Error404Component
    ]
})
export class CatalogViewComponent extends CatalogViewComponentDef {
    get productModel(): LocalProduct {
        return this.model as LocalProduct;
    }
}
